export default __webpack_public_path__ + "static/media/MP-20.196ecfab.png";